import React from 'react';
import { FaBook, FaCalendarAlt, FaList, FaUser } from 'react-icons/fa';

export default function ClassStats({ classes, teachers }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-blue-50 rounded-2xl flex items-center justify-center text-blue-600 mb-4">
                    <FaBook size={20} />
                </div>
                <div className="text-2xl font-black text-gray-900">{classes.length}</div>
                <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Total Classes</div>
            </div>
            <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-purple-50 rounded-2xl flex items-center justify-center text-purple-600 mb-4">
                    <FaCalendarAlt size={20} />
                </div>
                <div className="text-2xl font-black text-gray-900">
                    {classes.filter(c => c.type === 'Online').length}
                </div>
                <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Online Sessions</div>
            </div>
            <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-green-50 rounded-2xl flex items-center justify-center text-green-600 mb-4">
                    <FaList size={20} />
                </div>
                <div className="text-2xl font-black text-gray-900">
                    {classes.filter(c => c.type === 'Physical').length}
                </div>
                <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Physical Classes</div>
            </div>
            <div className="bg-white p-6 rounded-3xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow">
                <div className="w-12 h-12 bg-orange-50 rounded-2xl flex items-center justify-center text-orange-600 mb-4">
                    <FaUser size={20} />
                </div>
                <div className="text-2xl font-black text-gray-900">{teachers.length}</div>
                <div className="text-xs font-bold text-gray-400 uppercase tracking-wider">Total Teachers</div>
            </div>
        </div>
    );
}
